import Immutable from 'immutable';
import {
  FLAG_GETTING_CARGO_MINIMAL_PRICES,
  GET_CARGO_MINIMAL_PRICES,
  CLEAR_CARGO_MINIMAL_PRICES,
  FLAG_CARGO_MINIMAL_PRICE_ACTIVITY,
  CLEAR_CARGO_MINIMAL_PRICE,
  GET_CARGO_MINIMAL_PRICE,
} from '../../../actions/types/cargo';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CARGO_MINIMAL_PRICES:
      return state.setIn(['all', 'loading'], payload);
    case GET_CARGO_MINIMAL_PRICES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_MINIMAL_PRICES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CARGO_MINIMAL_PRICE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CARGO_MINIMAL_PRICE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_MINIMAL_PRICE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
